import { createElement, type ReactNode } from 'react';
import clsx from 'clsx';

export type EyebrowTone = 'default' | 'active';

export interface EyebrowProps {
  as?: 'p' | 'span' | 'div' | 'h2' | 'h3';
  className?: string;
  children: ReactNode;
  /** Prepend a literal `"> "` prefix in its own span. Default true. */
  prefix?: boolean;
  tone?: EyebrowTone;
}

export function Eyebrow({
  as = 'p',
  className,
  children,
  prefix = true,
  tone = 'default',
}: EyebrowProps) {
  const toneClass = tone === 'active' ? 'text-blue-deep' : 'text-ink-subtle';
  return createElement(
    as,
    {
      className: clsx(
        'font-mono text-[0.75rem] uppercase tracking-[0.125em]',
        toneClass,
        className,
      ),
    },
    prefix ? <span aria-hidden="true" className="zg-eyebrow-prefix">{'> '}</span> : null,
    children,
  );
}
